import * as React from 'react'
import { QueryResult } from '@apollo/client'
import Link from 'next/link'
import styled from 'styled-components'
import {
  GqlNotificationListQuery,
  GqlNotificationListQueryVariables,
} from 'generated/graphql'
import { TabType } from '@app.components/tabs/CardTabs/CardTabs'
import {
  NotificationCardMobile,
  NotificationCardMobileLoading,
} from '@app.feature/notification/component/NotificationCard'
import useIsWebview from '@app.modules/hooks/useIsWebview'
import Pagination from 'app.components/Pagination/Pagination'
import { EmptyNotification } from '../component/EmptyNotification'
import {
  handleClickDeleteNotificationType,
  handleClickNotificationType,
} from '../component/NotificationCard/NotificationCard.types'

type TProps = {
  className?: string
  selectedMenu?: string
  tabs: TabType[]
  query: QueryResult<
    GqlNotificationListQuery,
    GqlNotificationListQueryVariables
  >
  onClickNotification: handleClickNotificationType
  handleClickDeleteNotification: handleClickDeleteNotificationType
  handleClickDeleteAll: () => void
}

const ScreenNotificationMobile: React.FC<TProps> = ({
  className,
  selectedMenu,
  tabs,
  query,
  onClickNotification,
  handleClickDeleteNotification,
  handleClickDeleteAll,
}) => {
  const isWebview = useIsWebview()
  const { data, loading, error } = query
  return (
    <StyledWrapper className={className}>
      <div className="noti-header">
        <h1 className="noti-title">알림</h1>
        <div className="delete-btn" onClick={handleClickDeleteAll}>
          모두삭제
        </div>
      </div>
      <div className="noti-navbar">
        {tabs.map((tabs, idx) => (
          <Link key={idx} href={tabs.href || ''}>
            <a
              className="menu"
              data-active={selectedMenu === tabs.href?.query.tab}
            >
              {tabs.name} {`(${tabs.count || 0})`}
            </a>
          </Link>
        ))}
      </div>
      {/* loading */}
      {loading && (
        <div className="noti-list">
          {new Array(10).fill('').map((_, idx) => (
            <NotificationCardMobileLoading key={idx} />
          ))}
        </div>
      )}

      {/* error */}
      {!data || (error && <div>error</div>)}

      {/* data view */}
      {!loading && data && (
        <>
          <div className="noti-list">
            {/* empty data */}
            {data.viewerNotifications?.nodes.length === 0 && (
              <EmptyNotification />
            )}
            {data.viewerNotifications?.nodes.map((notification, idx) => (
              <NotificationCardMobile
                key={idx}
                data={notification!}
                onClick={onClickNotification}
                onClickDelete={handleClickDeleteNotification}
              />
            ))}
          </div>
          {data.viewerNotifications?.nodes.length !== 0 && (
            <Pagination
              className={isWebview ? 'webview-pagination' : 'pagination'}
              totalCount={data.viewerNotifications?.totalCount}
              pageSize={20}
              stepSize={5}
            />
          )}
        </>
      )}
    </StyledWrapper>
  )
}

export default ScreenNotificationMobile

const StyledWrapper = styled.div`
  .noti-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 13px 20px;
    border-bottom: 1px solid #e8e8e8;
    background-color: white;
    .noti-title {
      font-size: 16px;
      font-weight: bold;
    }
    .delete-btn {
      font-size: 14px;
    }
  }
  .noti-navbar {
    display: flex;
    gap: 15px;
    padding: 13px 20px;
    border-bottom: 1px solid #e8e8e8;
    background-color: #fafafa;
    .menu {
      color: #999;
      &[data-active='true'] {
        color: black;
      }
    }
  }
  .noti-list {
  }
  .webview-pagination {
    padding: 20px 0px 70px;
  }
  .pagination {
    padding: 20px 0;
  }
`
